import { SCode } from '../../../../common/constants/scode-status';
import { MonitoringStatus } from '../../../constants';
import { DeviationType } from '../../../models';

export class ShipmentLoadTransportOrderModel {
  transportOrderNumber: string;
  status: MonitoringStatus;
  statusCode: SCode;
  statusCodeDescription: string;
  departureTimeDeviation: number;
  arrivalTimeDeviation: number;
  delayed: boolean;
  inTime: DeviationType;
}
